import { DestinationEvent } from '@eventbrite/event-renderer';
import React from 'react';
import { BentoCarousel } from '../../components/BentoCarousel';
import styles from './BentoCarouselSection.module.scss';
import { useGetCategoryData } from './utils';

export interface BentoCarouselSectionProps {
    nearbyEvents: Array<DestinationEvent>;
    nearbyFreeEvents: Array<DestinationEvent>;
    nearbyNightlifeEvents: Array<DestinationEvent>;
    orderedCategories: string[];
    location_slug?: string;
    languageSubdirectory?: string;
}

const BentoCarouselSection: React.FC<BentoCarouselSectionProps> = ({
    nearbyEvents,
    nearbyFreeEvents,
    nearbyNightlifeEvents,
    orderedCategories,
    location_slug,
    languageSubdirectory,
}) => {
    const categoryEventData = useGetCategoryData({
        nearbyEvents,
        nearbyNightlifeEvents,
        nearbyFreeEvents,
        orderedCategories,
        location_slug,
        languageSubdirectory,
    });

    return (
        <section>
            {categoryEventData.map(({ key, title, events, url }) => (
                <div
                    key={key}
                    className={styles.singleBentoContainer}
                    data-testid="bento-carousel"
                >
                    <BentoCarousel
                        title={title}
                        titleURL={url}
                        events={events}
                        lazyLoadCarouselElements={true}
                    />
                </div>
            ))}
        </section>
    );
};

export default BentoCarouselSection;
